module.exports = __webpack_public_path__ + "img/Rolling-1s-50px.d890431c.gif";